module.exports = "/img/863873eebeaa6720021405768071e535.svg";